const PAGE_NAME = 'TASK_FILES_MASSIVE_DOWNLOADER';
const ACCOUNT_PREFERENCES = 'showRouteMassiveDownload';

export default { PAGE_NAME, ACCOUNT_PREFERENCES };